/**
 * Created by linjianxi on 2016/10/25.
 */

export const initReflectList = (store) => {
  return store
}



// WEBPACK FOOTER //
// ./src/vuex/modules/reflect/getter.js